// extracted by mini-css-extract-plugin
export default {"card":"rZ-z","carouselContainer":"sZ-z","carouselContent":"tZ-z"};